/** @format */

import React from "react";
import { useLocale } from "../i18n/hooks";
import {
  cookieDescriptors,
  createCookie,
  selectAllowCookies,
} from "./cookieSlice";
import "./cookiePopUp.scss";
import { useAppSelector } from "../../app/hooks";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
type cookieLocale = {
  en: cookieDescriptors;
  cy: cookieDescriptors;
};

const CookiePopUp: React.FC = () => {
  const locale = useLocale();
  const allowCookies = useAppSelector(selectAllowCookies());
  const dispatch = useDispatch<ThunkDispatch<boolean, boolean, any>>();

  const allowCookiesDescriptors: cookieLocale = {
    en: {
      title: "Cookies and privacy",
      paragraph:
        "We use cookies to improve user experience, and analyze website traffic. For these reasons, we may share your site usage data with our analytics partners. By clicking “Accept Cookies,” you consent to store on your device all the technologies described in our Cookie Policy.",
      link: "More information",
      button: "Accept cookies",
    },
    cy: {
      title: "Cwcis a  phreifatrwydd",
      paragraph:
        "Rydym yn defnyddio cwcis i wella profiad y defnyddiwr, a dadansoddi traffig gwefan. Am y rhesymau hyn, efallai y byddwn yn rhannu eich data defnydd gwefan gyda'n partneriaid dadansoddeg. Trwy glicio “Derbyn Cwcis,” rydych yn cydsynio i storio ar eich dyfais yr holl dechnolegau a ddisgrifir yn ein Polisi Cwcis.",
      link: "Mwy o wybodaeth",
      button: "Derbyn cwcis",
    },
  };

  return (
    <>
      {allowCookies === false &&
        window.localStorage.getItem("allowCookies") !== "true" && (
          <div
            role="banner"
            className={`allow-cookie-banner w-100 fixed-bottom bg-white p-4 shadow-lg ${
              allowCookies ? "d-none" : "d-block"
            }`}
          >
            <div className="container">
              <h1>{allowCookiesDescriptors[locale].title}</h1>
              <p>{allowCookiesDescriptors[locale].paragraph}</p>
              <div className="d-flex justify-content-between">
                <a
                  className="more-info text-primary"
                  title={allowCookiesDescriptors[locale].link}
                  href="https://www.wjec.co.uk/home/cookies/"
                >
                  {allowCookiesDescriptors[locale].link}
                </a>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    dispatch(createCookie(!allowCookies));
                  }}
                >
                  {allowCookiesDescriptors[locale].button}
                </button>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default CookiePopUp;
